var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumbs", {
        attrs: {
          two: { path: "/tuning", name: this.parent_section_name },
          three: "Автомобиль",
        },
      }),
      _c("div", { staticClass: "main" }, [
        _c("h3", [_vm._v(_vm._s(_vm.page_title))]),
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _vm.loading ? _c("loading") : _vm._e(),
            !_vm.loading
              ? _c(
                  "div",
                  [
                    _c("el-row", { attrs: { gutter: 24 } }),
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          {
                            attrs: {
                              span: 12,
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12,
                              xl: 12,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-card box-card is-always-shadow mb-4",
                              },
                              [
                                _c("div", { staticClass: "el-card__header" }, [
                                  _c("div", { staticClass: "clearfix" }, [
                                    _c("span", [_vm._v("Детали автомобиля")]),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "el-card__body" },
                                  [
                                    _c("span", [
                                      _vm._v("Tuning ID: "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.item.item_id)),
                                      ]),
                                      _c("hr"),
                                    ]),
                                    _c("span", [
                                      _vm._v("Бренд: "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.item.brand)),
                                      ]),
                                      _c("hr"),
                                    ]),
                                    _c("span", [
                                      _vm._v("Наименование: "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.item.title)),
                                      ]),
                                      _c("hr"),
                                    ]),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "TuningUpload",
                                            params: { id: _vm.id },
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              round: "",
                                              size: "mini",
                                              icon: "el-icon-upload",
                                              type: "warning",
                                            },
                                          },
                                          [_vm._v("Загрузить")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.items, border: "", stripe: "" },
                      },
                      [
                        [
                          _c("el-table-column", {
                            attrs: { label: "Название", prop: "name" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Картинка" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: scope.row.path,
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.path))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              251813740
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Дата обновления",
                              prop: "updated_at",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDate(scope.row.updated_at)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3280075892
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "right", width: "180" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          round: "",
                                          size: "mini",
                                          icon: "el-icon-delete",
                                          type: "warning",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteItemDialog(
                                              scope.row.id,
                                              scope.$index
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2388468243
                            ),
                          }),
                        ],
                      ],
                      2
                    ),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          visible: _vm.dialogVisible,
                          "show-close": true,
                          title: "Внимание!",
                        },
                      },
                      [
                        _c("div", [
                          _vm._v(" Вы действительно хотите удалить? "),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer",
                          },
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.dialogVisible = false
                                  },
                                },
                              },
                              [_vm._v("Нет")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.deleteItem },
                              },
                              [_vm._v("Да")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }